<template> 
</template>
<script>
import { mapActions } from 'vuex';
export default {
  name: 'hostel',
  components: {
  },
  data() {
    return {    
    };
  },
  mounted() {
    this.sentApp({
        action: 'finish',
        payload: {},
    });     
    this.sentApp({
        action: 'openExternalBrowser',
        payload: { url: 'https://epkaw.easycard.com.tw/secureRedirect?link=https%3A%2F%2Ftraiwan.com%2Fchannel%2Fuupay%2F&verify=d57fbb531dd34f85f97375b7e46372d01f34ed9f68070ff860d7404d4452add3' },
    });    
  },
  methods: {
    ...mapActions(['sentApp']),        
  },
};
</script>
<style lang="scss" scoped>
</style>
